import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { useCallback, useState } from 'react';
import { getModule } from '@jwp/ott-common/src/modules/container';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import AccountController from '@jwp/ott-common/src/controllers/AccountController';

import Button from '../Button/Button';
import FormFeedback from '../FormFeedback/FormFeedback';
import { modalURLFromLocation } from '../../utils/location';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay';

import styles from './SsoUserDetect.module.scss';

const SsoUserDetect = () => {
  const accountController = getModule(AccountController);

  const { t } = useTranslation(['user', 'common']);
  const email = useAccountStore((state) => state.user?.email);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [isSSOLogin, setIsSSOLogin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleCancel = useCallback(() => {
    navigate('/');
  }, [location, navigate]);

  const existUSerClickHandler = async () => {
    setIsSSOLogin(true);
    if (location?.state?.tokenData) {
      const tokenData = {
        token: location?.state?.tokenData.token,
        refreshToken: '',
        expires: location?.state?.tokenData.expires,
      };
      localStorage.setItem('inplayer_token', JSON.stringify(tokenData));
      const response = await accountController.ssoLogin(tokenData);

      if (response) {
        setIsSSOLogin(false);
      }
      navigate(modalURLFromLocation(location, null), { replace: true });
    }
  };

  return (
    <div className={styles.formContainer}>
      {errorMessage && (
        <div className={styles.formFeedback}>
          <FormFeedback variant="error">{errorMessage}</FormFeedback>
        </div>
      )}
      <h2 className={styles.heading}>{t('user:profile.sso_user_exist_header')}</h2>
      <p className={styles.paragraph}>{t('user:profile.sso_user_exist_content')}</p>
      <div className={styles.passwordButtonsContainer}>
        <Button
          type="submit"
          onClick={existUSerClickHandler}
          className={styles.button}
          color="primary"
          fullWidth
          label={t('common:confirmation_dialog.confirm')}
        />
        <Button type="button" onClick={handleCancel} className={styles.button} variant="text" fullWidth label={t('common:confirmation_dialog.close')} />
      </div>
      {isSSOLogin && <LoadingOverlay transparentBackground inline />}
    </div>
  );
};

export default SsoUserDetect;
